import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon, AlertTriangleIcon, SearchIcon, WrenchIcon, DollarSignIcon, HelpCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-14 bg-brand-dark relative border-t border-zinc-900" data-id="element-283">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-284">
        <FadeIn data-id="element-285">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-full mb-8" data-id="element-286">
            <AlertTriangleIcon className="w-5 h-5 text-brand-red" data-id="element-287" />
            <span className="text-sm font-bold tracking-widest text-zinc-400 uppercase" data-id="element-288">
              El Problema
            </span>
          </div>
        </FadeIn>

        <div className="space-y-6 text-lg md:text-xl text-zinc-300 font-medium" data-id="element-289">
          <FadeIn delay={0.1} data-id="element-290">
            <p data-id="element-291">
              Son las{' '}
              <span className="text-white font-bold" data-id="element-292">7:45 de la mañana</span> de
              un martes.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-293">
            <p data-id="element-294">Salís de tu casa con el monopatín.</p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-295">
            <p data-id="element-296">Apretás el botón de encendido.</p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-297">
            <p data-id="element-298">Y en exactamente 3 segundos, pasa lo que siempre pasa.</p>
          </FadeIn>
          <FadeIn delay={0.5} data-id="element-299">
            <p className="text-brand-red font-bold" data-id="element-300">
              La pantalla muestra un número rojo que nunca viste. Tres pitidos.
              Y el monopatín que no arranca.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} className="py-6" data-id="element-301">
            <p className="text-2xl md:text-3xl font-heading text-white tracking-wide" data-id="element-302">
              Mirás la pantalla.
              <br data-id="element-303" />
              Mirás el monopatín.
              <br data-id="element-304" />
              Mirás el reloj.
            </p>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-305">
            <p className="text-zinc-400" data-id="element-306">15 minutos para llegar al trabajo.</p>
            <p className="mt-8 text-white font-bold" data-id="element-307">
              Y empiezan los pensamientos de siempre:
            </p>
          </FadeIn>
        </div>

        <div className="mt-12 space-y-4" data-id="element-308">
          <FadeIn delay={0.1} direction="left" data-id="element-309">
            <div className="flex items-start gap-4 p-6 bg-zinc-900/50 border border-zinc-800/50 rounded-lg hover:border-brand-red/30 transition-colors" data-id="element-310">
              <SearchIcon className="w-6 h-6 text-zinc-500 shrink-0 mt-1" data-id="element-311" />
              <p className="text-zinc-300" data-id="element-312">
                La búsqueda de 40 minutos en Google que termina en videos en
                inglés que no explican nada
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="left" data-id="element-313">
            <div className="flex items-start gap-4 p-6 bg-zinc-900/50 border border-zinc-800/50 rounded-lg hover:border-brand-red/30 transition-colors" data-id="element-314">
              <ClockIcon className="w-6 h-6 text-zinc-500 shrink-0 mt-1" data-id="element-315" />
              <p className="text-zinc-300" data-id="element-316">
                El service más cercano que abre a las 10 y tiene turno para
                dentro de 5 días
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="left" data-id="element-317">
            <div className="flex items-start gap-4 p-6 bg-zinc-900/50 border border-zinc-800/50 rounded-lg hover:border-brand-red/30 transition-colors" data-id="element-318">
              <DollarSignIcon className="w-6 h-6 text-zinc-500 shrink-0 mt-1" data-id="element-319" />
              <p className="text-zinc-300" data-id="element-320">
                Los <span className="text-brand-red font-bold" data-id="element-321">$40.000</span>{' '}
                que te van a cobrar por algo que duró 20 minutos
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="left" data-id="element-322">
            <div className="flex items-start gap-4 p-6 bg-zinc-900/50 border border-zinc-800/50 rounded-lg hover:border-brand-red/30 transition-colors" data-id="element-323">
              <WrenchIcon className="w-6 h-6 text-zinc-500 shrink-0 mt-1" data-id="element-324" />
              <p className="text-zinc-300" data-id="element-325">
                La frustración de que la semana que viene puede volver a pasar
                exactamente igual
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} direction="left" data-id="element-326">
            <div className="flex items-start gap-4 p-6 bg-zinc-900/50 border border-zinc-800/50 rounded-lg hover:border-brand-red/30 transition-colors" data-id="element-327">
              <HelpCircleIcon className="w-6 h-6 text-zinc-500 shrink-0 mt-1" data-id="element-328" />
              <p className="text-zinc-300" data-id="element-329">
                La duda de si con este monopatín ya no hay solución
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} className="mt-10 text-center" data-id="element-330">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-331">
            ¿Cuánto te costó eso el año pasado?
          </h3>
          <p className="text-xl text-zinc-400 mb-4" data-id="element-332">
            En plata. En tiempo. En estrés. En llegadas tarde.
          </p>
          <p className="text-2xl text-brand-red font-bold" data-id="element-333">
            Si sos honesto... sabés que demasiado.
          </p>
        </FadeIn>
      </div>
    </section>;
}